<template>
    <kgr-searchable-dropdown
        ref="dropdown"
        display="displayWithCategory"
        :label="label"
        :options="filteredFees"
        :loading="loading"
        :inline="inline"
        @post-input="onInput"
    />
</template>

<script>
import MemberClubFeeRepository from '../../../../js/repository/MemberClubFeeRepository';
import SearchableDropdown from './SearchableDropdown.vue';

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            loading: true,
            clubFees: [],
        };
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('club.memberClubFees');
        },
        filteredFees() {
            return this.clubFees.filter((fee) => this.excludedIds.indexOf(fee.id) === -1);
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            MemberClubFeeRepository
                .findByMemberAndDefaultContext(this.memberId)
                .then((data) => {
                    this.loading = false;
                    this.clubFees = data;
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
